import _defineProperty from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { AbstractIcon } from './AbstractIcon';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const HistoryIcon = props => {
  return /*#__PURE__*/_jsx(AbstractIcon, _objectSpread(_objectSpread({}, props), {}, {
    "data-icon": "HistoryIcon",
    children: /*#__PURE__*/_jsxs("g", {
      children: [/*#__PURE__*/_jsx("path", {
        d: "M16.0608 12L13.2574 12C12.7051 12 12.2574 11.5523 12.2574 11L12.2574 6.44138",
        className: "stroke",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_jsx("path", {
        d: "M5.48349 12C5.48349 8.12219 8.62708 4.9786 12.5049 4.9786C16.3827 4.9786 19.5263 8.12219 19.5263 12C19.5263 15.8778 16.3827 19.0214 12.5049 19.0214C10.8967 19.0214 9.41478 18.4807 8.231 17.5713",
        className: "stroke",
        strokeLinecap: "round"
      }), /*#__PURE__*/_jsx("path", {
        d: "M5.15647 15.7343C5.3158 15.9605 5.65119 15.9605 5.81052 15.7343L7.99672 12.6303C8.18337 12.3653 7.99383 12 7.66969 12H3.2973C2.97316 12 2.78362 12.3653 2.97027 12.6303L5.15647 15.7343Z",
        className: "filled"
      })]
    })
  }));
};